import React from 'react';
import Icon from '../../../components/AppIcon';

const MessageBubble = ({ message, isUser, timestamp, isTyping = false }) => {
  const formatTime = (date) => {
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })?.format(date);
  };

  if (isTyping) {
    return (
      <div className="flex items-start space-x-3 mb-6">
        <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
          <Icon name="Bot" size={16} color="white" />
        </div>
        <div className="flex-1">
          <div className="bg-card border border-border rounded-organic p-4 shadow-organic">
            <div className="flex items-center space-x-2">
              <div className="flex space-x-1">
                <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              </div>
              <span className="text-sm text-muted-foreground">AI is thinking...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isUser) {
    return (
      <div className="flex items-start justify-end space-x-3 mb-6">
        <div className="flex-1 max-w-3xl">
          <div className="bg-primary text-primary-foreground rounded-organic p-4 shadow-organic">
            <p className="text-sm leading-relaxed whitespace-pre-wrap">{message}</p>
          </div>
          <div className="flex justify-end mt-1">
            <span className="text-xs text-muted-foreground">{formatTime(timestamp)}</span>
          </div>
        </div>
        <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center flex-shrink-0">
          <Icon name="User" size={16} color="white" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-start space-x-3 mb-6">
      <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
        <Icon name="Bot" size={16} color="white" />
      </div>
      <div className="flex-1 max-w-4xl">
        <div className="bg-card border border-border rounded-organic p-4 shadow-organic">
          <div className="prose prose-sm max-w-none">
            <div className="text-sm leading-relaxed text-card-foreground whitespace-pre-wrap">
              {message}
            </div>
          </div>
        </div>
        <div className="flex justify-start mt-1">
          <span className="text-xs text-muted-foreground">{formatTime(timestamp)}</span>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;